module.exports = __webpack_public_path__ + "img/Fist-White.b0f2ac7e.svg";